import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import DeltaWifiMenuContainer from './DeltaWifiMenuContainer';

const WrappedDeltaWifiMenuContainer = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <DeltaWifiMenuContainer {...props} />
    </Provider>
  );
};

WrappedDeltaWifiMenuContainer.propTypes = {
  $rootScope: PropTypes.shape({
    reduxStore: PropTypes.shape({}),
    nav: PropTypes.shape(),
  }).isRequired,
  $location: PropTypes.shape({
    search: PropTypes.func,
  }).isRequired,
  $route: PropTypes.shape({
    reload: PropTypes.func,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  isConciergeUser: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isGda: PropTypes.bool,
  onLogin: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  profilePhotoUrl: PropTypes.string,
};

WrappedDeltaWifiMenuContainer.defaultProps = {
  isGda: false,
  profilePhotoUrl: null,
};

export default WrappedDeltaWifiMenuContainer;
